import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { apiEndpoint } from 'configs'

const initialState = {
  data: [],
  loading: false,
  error: null,
  page: 0,
  size: 10,
  checkinStatus: null,
  notesStatus: null,
}

export const fetchAttendance = createAsyncThunk(
  'attendance/fetchAttendance',
  async ({ page = 0, size = 10 }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const response = await axios.get(
        `${apiEndpoint}/api/v1/bussines/userattendance/list?page=${page}&size=${size}`,
        config,
      )
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to fetch attendance',
      )
    }
  },
)

export const checkInOrOut = createAsyncThunk(
  'attendance/checkInOrOut',
  async (payload, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      const config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const response = await axios.post(
        `${apiEndpoint}/api/v1/bussines/userattendance/checkinorout`,
        payload,
        config,
      )
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to check in/out',
      )
    }
  },
)

export const setAttendanceNotes = createAsyncThunk(
  'attendance/setNotes',
  async ({ notes }, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState()
      let config = {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${auth.token}`,
        },
      }
      const response = await axios.post(
        `${apiEndpoint}/api/v1/bussines/userattendance/setnotes`,
        { notes },
        config,
      )
      return response.data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to set notes',
      )
    }
  },
)

const attendanceSlice = createSlice({
  name: 'attendance',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(fetchAttendance.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchAttendance.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload.data || []
      })
      .addCase(fetchAttendance.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      .addCase(checkInOrOut.pending, (state) => {
        state.checkinStatus = 'loading'
      })
      .addCase(checkInOrOut.fulfilled, (state) => {
        state.checkinStatus = 'success'
      })
      .addCase(checkInOrOut.rejected, (state, action) => {
        state.checkinStatus = `error: ${action.payload}`
      })

      .addCase(setAttendanceNotes.pending, (state) => {
        state.notesStatus = 'loading'
      })
      .addCase(setAttendanceNotes.fulfilled, (state) => {
        state.notesStatus = 'success'
      })
      .addCase(setAttendanceNotes.rejected, (state, action) => {
        state.notesStatus = `error: ${action.payload}`
      })
  },
})

export default attendanceSlice.reducer
